import { BodyText } from "@/components/ui";
import type { PatientDemographics } from "../types/patientDemographics";

interface ClinicalInfoProps {
  clinical: PatientDemographics["clinical"];
}

export const ClinicalInfo = ({ clinical }: ClinicalInfoProps) => {
  if (!clinical) return null;

  return (
    <BodyText textColor="primary" size="sm">
      {clinical.pcpName || "Not Assigned"}
    </BodyText>
  );
};
